import React from "react"
import Layout from "../components/layout"
import { Link, graphql } from "gatsby"
import Seo from "../components/seo"
import {
  // LazyLoadImage,
  LazyLoadComponent,
} from "react-lazy-load-image-component"
import { StaticImage, GatsbyImage } from "gatsby-plugin-image"
import { FaLinkedin } from "react-icons/fa"
import loadable from "@loadable/component"
import pMinDelay from "p-min-delay"
import "./about.css"
import { FaPlus } from "react-icons/fa"

const Modal = loadable(() =>
  pMinDelay(import("../components/modal/team-modal"), 500)
)

const Hero = loadable(() =>
  pMinDelay(import("../components/hero/hero-about.js"), 500)
)

const QuandaryValues = loadable(() =>
  pMinDelay(import("../components/new-quandary/quandary-values-about"), 500)
)

const ImageSwiper = loadable(() =>
  pMinDelay(import("../components/swiper/about-swiper.js"), 500)
)

class AboutPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      teambio: null,
    }
  }

  render() {
    console.log("team modal test", this.state.teambio)

    const { data } = this.props
    const teams = data.allSanityTeam.edges
    return (
      <Layout location={this.props.location}>
        <Seo
          title="About Us | Quandary Consulting Group"
          description="Quandary solves complex ops problems with low-code and AI. And we do it with a team trained to lead, adapt, and challenge how work gets done."
        />
        <Hero />
        <section style={{ padding: "3rem 0", backgroundColor: "#f8f8f8" }}>
          <div className="container">
            <div className="row mb-4 text-center">
              <div className="col-12">
                <h2 className="about-titlehead">
                  Peak or Problem? We Help You Conquer Both.
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4 md-mb-0 mb-mobile-extra d-flex">
                <div
                  className="card border-0 shadow-sm w-100"
                  style={{ position: "relative" }}
                >
                  <StaticImage
                    placeholder="blurred"
                    className="card-img-top rounded-md"
                    src="../images/new-images/quandary-peak.jpg"
                    alt="Quandary Peak, Colorado 14,265 feet"
                    style={{ objectFit: "cover", height: "22rem" }}
                    loading="lazy"
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-2rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                      padding: "1.5rem 4rem",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      fontWeight: "500",
                      fontSize: "15px",
                      width: "calc(100% - 4rem)",
                      textAlign: "center",
                    }}
                  >
                    Quandary Peak – Colorado, 14,265 feet
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-4 d-flex">
                <div
                  className="card border-0 shadow-sm w-100"
                  style={{ position: "relative" }}
                >
                  <StaticImage
                    placeholder="blurred"
                    className="card-img-top rounded-md"
                    src="../images/new-images/quandary-state.jpg"
                    alt="Quandary state of mind"
                    style={{ objectFit: "cover", height: "22rem" }}
                    loading="lazy"
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-2rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                      padding: "0.75rem 2rem",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      fontWeight: "500",
                      fontSize: "15px",
                      width: "calc(100% - 4rem)",
                      textAlign: "center",
                    }}
                  >
                    Quandary, the state of uncertainty over what to do in
                    difficult situations.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: "3rem 0", background: "#00293A" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 text-left text-white">
                <h2 className="mb-4 text-white">Our Origin Story</h2>
                <p>
                  Quandary exists because we saw too many teams stuck with
                  surface-level solutions—projects scoped to match a request
                  instead of solving real problems.
                </p>
                <p>We work differently.</p>
                <p>
                  Our team moves fast across silos, tools, and teams, building
                  what actually works in the real world.
                </p>
                <p>Low code gives us speed. AI expands the frontier.</p>
                <p>
                  But tech is just a piece of the puzzle. At the core, we help
                  teams evolve.
                </p>
                <p>
                  {" "}
                  <strong>Even when the plan falls apart.</strong>
                </p>
                <p>
                  In the process, we give teams back time to focus on what
                  actually matters: strategic work, time with family, and
                  evenings spent anywhere but inside a spreadsheet.
                </p>
              </div>

              <div className="col-lg-6" style={{ padding: "3rem 0" }}>
                <div className="timeline">
                  <div className="timeline-item text-white">
                    <span className="timeline-year">2015</span>
                    <p>
                      <strong>
                        Quandary founded with Quickbase and Workato Partnerships
                      </strong>
                    </p>
                    <hr className="timeline-divider" />
                  </div>
                  <div className="timeline-item text-white">
                    <span className="timeline-year">2019</span>
                    <p>
                      <strong>Annual in-person team retreats begin</strong>
                    </p>
                    <hr className="timeline-divider" />
                  </div>
                  <div className="timeline-item text-white">
                    <span className="timeline-year">2022</span>
                    <p>
                      <strong>
                        Internal training program launched to grow non-technical
                        consultants
                      </strong>
                    </p>
                    <hr className="timeline-divider" />
                  </div>
                  <div className="timeline-item text-white">
                    <span className="timeline-year">2023</span>
                    <p>
                      <strong>TrackVia partnership formalized</strong>
                    </p>
                    <hr className="timeline-divider" />
                  </div>
                  <div className="timeline-item text-white">
                    <span className="timeline-year">2024</span>
                    <p>
                      <strong>Expanded services to AI</strong>
                    </p>
                    <hr className="timeline-divider" />
                  </div>
                  <div className="timeline-item text-white">
                    <span className="timeline-year">2025 - Present</span>
                    <p>
                      <strong>
                        Helping clients navigate the next wave of change with
                        AI, LLMs, and whatever comes next.
                      </strong>
                    </p>
                    <hr className="timeline-divider" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="peaks" style={{ paddingBottom: "3rem" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto text-center text-left-mobile">
                <h2>PEAKS Is How We Operate</h2>
                <p>
                  These values shape how we work, how we grow, and how we show
                  up for each other under real pressure.
                </p>
              </div>
              <div className="col-lg-12 mt-3">
                <QuandaryValues />
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: "3rem 0", backgroundColor: "#F8F8F8" }}>
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-6">
                <p className="h2 mb-6">What It's Like to Work With Us</p>
                <p className="mb-6 mt-4">We don't show up with scripts.</p>
                <p>
                  We show up to lead, ask sharper questions, figure out what
                  will work, and guide your team. That means pressure, pivots,
                  and sometimes failing forward when that's what it takes to get
                  it right.
                </p>
                <p>Whether you're a client or a team member, you'll feel it:</p>
                <p>
                  We're not here to play it safe. We're here to challenge how
                  things have always been done and find better ways to operate.
                </p>
              </div>
              <div className="col-lg-6 mt-lg-0 mt-md-0 mt-3 align-self-center pb-lg-0 pb-5">
                <StaticImage
                  className="rounded w-100 img-fluid"
                  placeholder="blurred"
                  src="https://cdn.sanity.io/images/55lcecww/production/7fd2304577e2baa39661ed0e4612e65cb2c26279-1544x1536.jpg"
                  alt="Why Choose Quandary"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>
        <ImageSwiper />
        <section
          className="bg-indigo about-us"
          style={{
            padding: "3rem 0",
          }}
        >
          <div className="container">
            <div className="row align-items-stretch">
              <div className="col-lg-6 d-flex flex-column justify-content-center">
                <h2 className="text-white mb-4 text-left-mobile">
                  We Don’t Just Hire Talent—We Build It
                </h2>
                <p className="text-white mb-4 text-left-mobile">
                  Great client outcomes don’t come from pre-baked résumés. They
                  come from people who are hungry to learn, unafraid to lead,
                  and trusted to grow.
                </p>
                <p className="text-white mb-2 text-left-mobile">
                  Our training program takes people with zero background in tech
                  and turns them into effective consultants in weeks.
                </p>
                <div className="about-us-xp">
                  <ul className="text-white">
                    <li className="mb-2">Approach complex problems</li>
                    <li className="mb-2">Find solutions and adapt</li>
                    <li className="mb-2">Deliver under pressure</li>
                    <li>And guide clients independently</li>
                  </ul>
                </div>
                <p className="text-white mt-3 mb-3">
                  Just like the rest of our team.
                </p>
              </div>

              <div className="col-lg-6 d-flex">
                <div className="w-100">
                  <div className="row g-4 mb-2">
                    <div className="col-6">
                      <StaticImage
                        src="https://cdn.sanity.io/images/55lcecww/production/bca7c135ebe5b6d307865bd65642faafd8847155-768x1024.jpg"
                        alt="Image 1"
                        className="img-fluid"
                        loading="lazy"
                        placeholder="blurred"
                        style={{
                          objectFit: "cover",
                          height: "100%",
                        }}
                      />
                    </div>
                    <div className="col-6">
                      <StaticImage
                        src="https://cdn.sanity.io/images/55lcecww/production/349fe3a4f9dc272902b1ca7bdc43fdf1689b6655-768x1024.jpg"
                        alt="Image 2"
                        className="img-fluid"
                        loading="lazy"
                        placeholder="blurred"
                        style={{
                          objectFit: "cover",
                          height: "100%",
                        }}
                      />
                    </div>
                  </div>

                  <div className="row g-4 mt-4">
                    <div className="col-12">
                      <StaticImage
                        src="https://cdn.sanity.io/images/55lcecww/production/207ed970dc89889422b5a7665d04468042b5929e-1024x768.jpg"
                        alt="Image 3"
                        className="img-fluid"
                        loading="lazy"
                        placeholder="blurred"
                        style={{
                          objectFit: "cover",
                          height: "90%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="team"
          style={{
            padding: "3rem 0",
            background: "#fff",
          }}
        >
          <div className="container">
            <div className="intro text-center mb-5">
              <p className="h5 text-light-blue text-uppercase font-weight-bold mb-lg-1 mb-1 about-titlehead">
                LEADERSHIP TEAM
              </p>
            </div>
            <div className="row px-5">
              {teams.map(({ node }) => (
                <div className="col-md-4 col-lg-3 px-4 px-lg-4 px-md-3">
                  <div className="quandary-team-member mb-4">
                    <div className="quandary-team-member-inner">
                      <div className="quandary-team-image">
                        {node?.image?.asset?.gatsbyImageData ? (
                          <GatsbyImage
                            image={node?.image?.asset?.gatsbyImageData}
                            imgClassName="img-fluid"
                            alt={node?.name}
                            // width={600}
                            placeholder="blurred"
                            style={{ height: "16rem", width: "100%" }}
                          />
                        ) : (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              height: "256px",
                              width: "270px",
                              backgroundColor: "#f7f2f2",
                            }}
                          >
                            {" "}
                            <svg width="208" height="208" viewBox="0 0 480 480">
                              <path
                                fill="currentColor"
                                d="M240 0C107.664 0 0 107.664 0 240c0 57.96 20.656 111.184 54.992 152.704.088.12.096.272.192.384 24.792 29.896 55.928 52.816 90.624 67.624.4.168.792.352 1.192.52 2.808 1.184 5.648 2.28 8.496 3.352 1.12.424 2.24.856 3.376 1.264 2.456.88 4.928 1.712 7.416 2.512 1.592.512 3.184 1.016 4.792 1.496 2.2.656 4.408 1.288 6.632 1.888 1.952.528 3.92 1.016 5.888 1.488 1.992.48 3.992.96 6 1.384 2.24.48 4.504.904 6.776 1.32 1.824.336 3.64.688 5.48.984 2.52.408 5.056.728 7.6 1.056 1.64.208 3.272.448 4.92.624 2.88.304 5.784.52 8.696.72 1.352.096 2.696.24 4.056.312 4.248.24 8.544.368 12.872.368s8.624-.128 12.888-.352c1.36-.072 2.704-.216 4.056-.312 2.912-.208 5.816-.416 8.696-.72 1.648-.176 3.28-.416 4.92-.624 2.544-.328 5.08-.648 7.6-1.056 1.832-.296 3.656-.648 5.48-.984 2.264-.416 4.528-.84 6.776-1.32 2.008-.432 4-.904 6-1.384 1.968-.48 3.936-.968 5.888-1.488a232.661 232.661 0 0011.424-3.384c2.488-.8 4.96-1.632 7.416-2.512 1.128-.408 2.248-.84 3.376-1.264a243.168 243.168 0 008.496-3.352c.4-.168.792-.352 1.192-.52a239.997 239.997 0 0090.624-67.624c.096-.112.104-.272.192-.384C459.344 351.184 480 297.96 480 240 480 107.664 372.336 0 240 0zm97.256 441.76c-.12.056-.232.12-.352.176-2.856 1.376-5.76 2.672-8.688 3.936-.664.28-1.32.568-1.984.848a217.023 217.023 0 01-7.76 3.064 159.85 159.85 0 01-3.272 1.192 230.572 230.572 0 01-6.976 2.368c-1.456.464-2.92.904-4.384 1.336a202.08 202.08 0 01-6.28 1.784c-1.776.472-3.568.904-5.36 1.328-1.88.448-3.752.904-5.648 1.304-2.072.44-4.16.816-6.24 1.192-1.688.312-3.368.64-5.072.912-2.344.368-4.712.664-7.072.96-1.496.192-2.984.416-4.496.576-2.696.288-5.416.472-8.128.664-1.208.08-2.408.216-3.632.28-3.96.208-7.928.32-11.912.32s-7.952-.112-11.904-.32c-1.216-.064-2.416-.192-3.632-.28-2.72-.184-5.432-.376-8.128-.664-1.512-.16-3-.384-4.496-.576-2.36-.296-4.728-.592-7.072-.96-1.704-.272-3.384-.6-5.072-.912-2.088-.376-4.176-.76-6.24-1.192-1.896-.4-3.776-.856-5.648-1.304-1.792-.432-3.584-.856-5.36-1.328-2.104-.56-4.2-1.168-6.28-1.784a212.543 212.543 0 01-4.384-1.336 223.256 223.256 0 01-6.976-2.368 217.023 217.023 0 01-11.032-4.256c-.664-.272-1.312-.56-1.976-.84a223.812 223.812 0 01-8.696-3.936 7.216 7.216 0 01-.352-.176c-27.912-13.504-52.568-32.672-72.576-55.952 15.464-56.944 59.24-102.848 115.56-121.112 1.112.68 2.272 1.288 3.416 1.928.672.376 1.336.776 2.016 1.136a99.592 99.592 0 007.272 3.512c1.896.832 3.856 1.536 5.808 2.256.384.136.768.288 1.152.424 10.848 3.84 22.456 6.04 34.6 6.04s23.752-2.2 34.592-6.04c.384-.136.768-.288 1.152-.424 1.952-.72 3.912-1.424 5.808-2.256a99.592 99.592 0 007.272-3.512c.68-.368 1.344-.76 2.016-1.136 1.144-.64 2.312-1.248 3.432-1.936 56.32 18.272 100.088 64.176 115.56 121.112-20.008 23.272-44.664 42.44-72.576 55.952zM152 176c0-48.52 39.48-88 88-88s88 39.48 88 88c0 30.864-16.008 58.024-40.128 73.736a84.742 84.742 0 01-9.8 5.48c-.4.192-.792.392-1.192.576-23.168 10.536-50.592 10.536-73.76 0-.4-.184-.8-.384-1.192-.576a84.083 84.083 0 01-9.8-5.48C168.008 234.024 152 206.864 152 176zm269.832 194.584c-18.136-53.552-59.512-96.832-112.376-117.392C330.6 234.144 344 206.64 344 176c0-57.344-46.656-104-104-104s-104 46.656-104 104c0 30.64 13.4 58.144 34.552 77.192-52.864 20.568-94.24 63.84-112.376 117.392C31.672 333.792 16 288.704 16 240 16 116.488 116.488 16 240 16s224 100.488 224 224c0 48.704-15.672 93.792-42.168 130.584z"
                              ></path>
                            </svg>
                          </div>
                        )}
                        <div className="row pt-3 pl-2">
                          <div>
                            {" "}
                            <Modal teambio={node} />
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <p
                              className="h4 mb-0 mr-2 quandary-team-name"
                              style={{ color: "#00b5f4" }}
                            >
                              {node.name}
                            </p>
                            {node.linkedin ? (
                              <a
                                href={node.linkedin}
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex align-items-center mb-0"
                                style={{
                                  position: "relative",
                                  zIndex: "1",
                                }}
                              >
                                <span
                                  style={{
                                    background: "#fff",
                                    // padding: "0.1rem 0.5rem",
                                    borderRadius: "0.2rem",
                                  }}
                                >
                                  <FaLinkedin
                                    color="#0D65A6"
                                    style={{ height: "2em", width: "1.2em" }}
                                  />
                                </span>
                              </a>
                            ) : (
                              <a
                                href={node.linkedin}
                                target="_blank"
                                rel="noreferrer"
                                className="d-flex align-items-center mb-2"
                              >
                                <p className="h4 mb-0">{node.name}</p>
                              </a>
                            )}
                          </div>
                        </div>
                        <small className="mb-0">{node.position}</small>

                        {/* <p className="mb-0">
                          {node.bio && node.bio.children
                            ? node.bio.children.map((child, index) => (
                                <span key={index}>{child.text} </span>
                              ))
                            : null}
                        </p> */}
                      </div>

                      <div className="quandary-team-social" />

                      {/* <a
                        // aria-label="button"
                        className="h6 mb-0 mr-2 pe-auto"
                        onClick={this.handleShow}
                      >
                        View Bio
                      </a> */}

                      {/* <button onClick={() => this.setState({ teambio: node })}>
                        View Bio
                      </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section
          className="bg-case-study slogan-section"
          style={{
            paddingTop: "5rem",
            paddingBottom: "5rem",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div>
                  <h2 className="text-white">
                    Challenge Assumptions, Fail Forward, and Build Change Into
                    How Businesses Run
                  </h2>
                  {/* <p className="text-white">
                  Our 10-point security audit will show you how secure your
                  applications are. <br /> Protect your data. Protect your
                  investment. Protect your organization.
                </p> */}

                  <Link
                    to="/careers/"
                    className="btn btn-primary btn-arrow mr-2 mt-4 text-center py-3 text-uppercase"
                    style={{ marginTop: "auto" }}
                  >
                    Join Our Team
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default AboutPage

export const TeamQuery = graphql`
  query TeamQuery {
    allSanityTeam(sort: { fields: [order], order: ASC }) {
      edges {
        node {
          id
          state
          address
          name
          linkedin
          position
          image {
            asset {
              gatsbyImageData(
                fit: FILL
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
              )
            }
          }
          bio
        }
      }
    }
  }
`
